import FirstFinancialBank from "../icons/FirstFinancialBank";
import React from "react";
import styles from "./Header.module.css";

export default function Header() {
    return (
        <header className={styles.container}>
            <FirstFinancialBank className={styles.firstLogo} />
        </header>
    );
}
